<template>
  <CLoading :loading="loading" />
  <q-table
    bordered
    flat
    dense
    title="Treats"
    ref="welcomeList"
    v-if="richMenus"
    :rows="richMenus"
    row-key="title"
    :rows-per-page-options="[10]"
    separator="cell"
    :no-data-label="$t('messages.no_data_available')"
    class="text-grey-8"
  >
    <template v-slot:header="props">
      <q-tr>
        <q-th rowspan="2" key="action" class="text-center" style="width: 50px"
          ><span class="text-bold">{{ $t('label.prod') }}</span></q-th
        >
        <q-th rowspan="2" key="action" class="text-center" style="width: 50px"
          ><span class="text-bold">{{ $t('label.test') }}</span></q-th
        >
        <q-th rowspan="2" key="action" class="text-center" style="width: 200px"></q-th>
        <q-th :props="props" rowspan="2" class="text-center" key="name">
          <span class="text-bold">リッチメニュー名</span>
        </q-th>
        <q-th :props="props" key="created_at">
          <span class="text-bold">{{ $t('label.created_at') }}</span>
        </q-th>
        <q-th :props="props" key="creator_name">
          <span class="text-bold">{{ $t('label.story.creator_name') }}</span>
        </q-th>
        <q-th :props="props" key="updated_at">
          <span class="text-bold">{{ $t('label.updated_at') }}</span>
        </q-th>
        <q-th :props="props" key="updater_name">
          <span class="text-bold">{{ $t('label.story.updater_name') }}</span>
        </q-th>
      </q-tr>
    </template>
    <template v-slot:body="props">
      <q-tr :props="props" :index="props.rowKey">
        <q-td>
          <q-toggle
            round
            v-model="props.row.is_active"
            val="props.row.is_active"
            @click="handleToggleActive(props.row)"
          />
        </q-td>
        <q-td>
          <q-toggle
            round
            v-model="props.row.is_test_mode"
            val="props.row.is_test_mode"
            @click="handleToggleTest(props.row)"
          />
        </q-td>
        <q-td class="text-center">
          <q-btn size="sm" flat round icon="edit" @click="onEdit(props.row)" />
          <app-copy-button @click="onCopy(props.row)" />
          <q-btn size="sm" flat round color="red" icon="mdi-trash-can" @click="onDelete(props.row)" />
          <q-btn size="sm" flat round icon="visibility" @click="onPreview(props.row)" />
        </q-td>
        <q-td key="name" :props="props">
          <span>{{ props.row.name }}</span
          ><br />
          <a
            :href="getDetailsUrl(props.row)"
            @click="onDetails($event, props.row)"
            class="cursor-pointer hyper-link-chart"
          >
            {{ $t('label.data_transition') }}
          </a>
          <span>/{{ props.row._id.length > 4 ? props.row._id.slice(0, 4) + '***' : props.row._id }}</span>
        </q-td>
        <q-td key="created_at" :props="props">
          <span>{{ props.row.created_at }}</span>
        </q-td>
        <q-td key="creator_name" :props="props">
          <span>{{ props.row.creator_name }}</span>
        </q-td>
        <q-td key="created_at" :props="props">
          <span>{{ props.row.updated_at }}</span>
        </q-td>
        <q-td key="updater_name" :props="props">
          <span>{{ props.row.updater_name }}</span>
        </q-td>
      </q-tr>
    </template>

    <template v-slot:top>
      <h2 class="text-h6 text-black">{{ $t('label.rich_menu.rich_menu_list') }}</h2>
      <q-space />
      <q-btn no-caps class="btn-save" size="sm" @click="onAdd()" :label="$t('add_new')" />
      <span class="text-caption q-ml-md q-mr-sm">表示条件設定:</span>
      <q-btn-group>
        <q-btn
          size="sm"
          :class="conditionSetting.display_setting ? 'btn-save' : 'btn-save-grey'"
          label="あり"
          @click="onChangeDisplaySetting(true, conditionSetting.display_setting)"
        />
        <q-btn
          size="sm"
          :class="!conditionSetting.display_setting ? 'btn-save' : 'btn-save-grey'"
          label="なし"
          @click="onChangeDisplaySetting(false, conditionSetting.display_setting)"
        />
      </q-btn-group>
      <q-btn
        no-caps
        class="q-ml-md"
        size="sm"
        label="表示条件設定"
        @click="openConditionSetting"
        :class="conditionSetting.display_setting ? 'btn-save' : 'btn-save-grey'"
      />
    </template>
  </q-table>
  <RichMenuPreviewModal
    v-if="modalPreviewVisible"
    :modalVisible="modalPreviewVisible"
    :richMenu="selectedIRichMenu"
    @update:closeModal="onClosePreviewModal"
  />
  <ConditionSettingModal
    v-if="conditionSettingModalVisible"
    :modalVisible="conditionSettingModalVisible"
    :settingData="conditionSetting"
    :activeRichMenus="activeRichMenus"
    :testRichMenus="testRichMenus"
    :appId="selectedAppId"
    @update:closeModal="onCloseSettingModal"
    @onUpdateSettings="updateConditionSetting"
  />
  <DefaultRichMenuModal
    v-if="defaultRichMenuModalVisible"
    :richMenus="richMenus"
    :modalVisible="defaultRichMenuModalVisible"
    @update:closeModal="onCloseDefaultRichMenuModal"
    @update:defaultRichMenu="setDefaultRichMenu"
  />
</template>

<script lang="ts">
import { Options, mixins } from 'vue-class-component'
import { maska } from 'maska'
import { IRichMenu, IRichMenuConditionSetting } from '@/utils/types'
import { Watch } from 'vue-property-decorator'
import { ACTION_RICH_MENU, ACTION_RICH_MENU_CONDITION_SETTING } from '@/store/actions'
import CLoading from '@/components/common/ui/CLoading.vue'
import { constant } from '@/utils/constants'
import BaseFormMixin from '../common/mixins/BaseFormMixin.vue'
import RichMenuPreviewModal from '@/components/rich-menus/RichMenuPreviewModal.vue'
import cloneDeep from 'lodash/cloneDeep'
import ConditionSettingModal from '@/components/rich-menus/ConditionSettingModal.vue'
import DefaultRichMenuModal from '@/components/rich-menus/DefaultRichMenuModal.vue'

@Options({
  components: { DefaultRichMenuModal, ConditionSettingModal, RichMenuPreviewModal, CLoading },
  directives: { maska },
  emits: ['update:changeTab'],
})
export default class RichMenus extends mixins(BaseFormMixin) {
  loading = true
  selectedIRichMenu: IRichMenu = {}
  modalPreviewVisible = false
  conditionSettingModalVisible = false
  defaultRichMenuModalVisible = false

  conditionSetting: IRichMenuConditionSetting = {
    _id: '',
    app_id: '',
    display_setting: false,
    prod_detail: {
      default_rich_menu_id: '',
      priority_rich_menu: [],
    },
    test_detail: {
      default_rich_menu_id: '',
      priority_rich_menu: [],
    },
  }

  get richMenus() {
    return cloneDeep(this.$store.getters.richMenus) || []
  }

  get selectedAppId() {
    return this.$route.params.app_id
  }

  get activeRichMenus() {
    return this.richMenus.filter((item) => item.is_active === true)
  }

  get testRichMenus() {
    return this.richMenus.filter((item) => item.is_test_mode === true)
  }

  @Watch('selectedAppId', { immediate: true })
  async appIdChanged() {
    if (!this.selectedAppId) {
      return
    }

    await this.$store.dispatch(ACTION_RICH_MENU.LOAD_ITEMS, {
      app_id: this.selectedAppId,
    })

    const result = await this.$store.dispatch(ACTION_RICH_MENU_CONDITION_SETTING.LOAD_ITEM, {
      app_id: this.selectedAppId,
    })
    if (result._id) {
      this.conditionSetting = { ...this.conditionSetting, ...cloneDeep(result) }
    } else {
      this.conditionSetting.app_id = this.selectedAppId as string
    }

    this.loading = false
  }

  async updateIsActive(item: IRichMenu) {
    const isSuccess = await this.$store.dispatch(ACTION_RICH_MENU.IS_ACTIVE, item)
    if (isSuccess) {
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
    }

    return isSuccess
  }

  async updateTestMode(item: IRichMenu) {
    const isSuccess = await this.$store.dispatch(ACTION_RICH_MENU.TEST_MODE, item)
    if (isSuccess) {
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
    }

    return isSuccess
  }

  async handleToggleActive(record: IRichMenu) {
    if (this.conditionSetting.display_setting) {
      this.$q
        .dialog({
          title: this.$t('messages.confirm'),
          message: this.$t('messages.are_you_sure_to_turn_on_active_for_this_item'),
          cancel: {
            flat: true,
            label: this.$t('messages.no'),
          },
          ok: {
            flat: true,
            label: this.$t('messages.yes'),
          },
          persistent: true,
        })
        .onOk(async () => {
          await this.updateIsActive(record)
        })
        .onCancel(async () => {
          record.is_active = false
        })
    } else {
      const menu = this.richMenus.find((item) => item._id !== record._id && item.is_active === true)
      if (!menu) {
        if (!record.is_active) {
          await this.updateIsActive(record)
        } else {
          this.$q
            .dialog({
              title: this.$t('messages.confirm'),
              message: this.$t('messages.are_you_sure_to_turn_on_active_for_this_item'),
              cancel: {
                flat: true,
                label: this.$t('messages.no'),
              },
              ok: {
                flat: true,
                label: this.$t('messages.yes'),
              },
              persistent: true,
            })
            .onOk(async () => {
              await this.updateIsActive(record)
            })
            .onCancel(async () => {
              record.is_active = false
            })
        }
      } else {
        this.$q
          .dialog({
            title: this.$t('messages.confirm'),
            message: this.$t('messages.please_diasble_all_before_this_feature_in_enabled'),
            cancel: {
              flat: true,
              label: this.$t('cancel'),
            },
            persistent: true,
          })
          .onOk(async () => {
            menu.is_active = false
            await this.updateIsActive(menu)
          })
        record.is_active = false
      }
    }
  }

  async handleToggleTest(record: IRichMenu) {
    if (this.conditionSetting.display_setting) {
      await this.updateTestMode(record)
    } else {
      const menu = this.richMenus.find((item) => item._id !== record._id && item.is_test_mode === true)
      if (!menu) {
        await this.updateTestMode(record)
      } else {
        this.$q
          .dialog({
            title: this.$t('messages.confirm'),
            message: this.$t('messages.please_diasble_all_before_this_feature_in_enabled'),
            cancel: {
              flat: true,
              label: this.$t('cancel'),
            },
            persistent: true,
          })
          .onOk(async () => {
            menu.is_test_mode = false
            await this.updateTestMode(menu)
          })
        record.is_test_mode = false
      }
    }
  }

  onAdd() {
    this.goto('rich_menu_setting', { app_id: this.selectedAppId, action_type: constant.ACTION_TYPE.ADD })
  }

  onCopy(data: IRichMenu) {
    this.goto('rich_menu_setting', {
      app_id: this.selectedAppId,
      rich_menu_id: data._id,
      action_type: constant.ACTION_TYPE.COPY,
    })
  }

  onEdit(data: IRichMenu) {
    this.goto('rich_menu_setting', {
      app_id: this.selectedAppId,
      rich_menu_id: data._id,
      action_type: constant.ACTION_TYPE.EDIT,
    })
  }

  async onDelete(data: IRichMenu) {
    this.$q
      .dialog({
        title: this.$t('confirm'),
        message: this.$t('are_you_sure_you_want_to_delete'),
        cancel: true,
        persistent: true,
      })
      .onOk(async () => {
        const success = await this.$store.dispatch(ACTION_RICH_MENU.DELETE, data._id)
        if (success) {
          this.$q.notify({
            message: this.$t('messages.deleted'),
            color: 'positive',
          })
        }
      })
  }

  async onPreview(richMenu: IRichMenu) {
    this.selectedIRichMenu = richMenu
    this.modalPreviewVisible = true
  }

  onClosePreviewModal() {
    this.selectedIRichMenu = {}
    this.modalPreviewVisible = false
  }

  getDetailsUrl(data) {
    return this.$router.resolve({
      name: 'rich_menu_setting',
      params: {
        app_id: this.selectedAppId,
        action_type: 'edit',
        rich_menu_id: data._id,
      },
    }).href
  }

  onDetails(event, data: IRichMenu) {
    // Check if Ctrl (Windows) or Meta (Mac) is pressed
    if (event.ctrlKey || event.metaKey) {
      // Let the browser handle opening in a new tab
      return
    }
    // Otherwise, navigate programmatically
    event.preventDefault()

    this.goto('rich_menu_setting', {
      app_id: this.selectedAppId,
      action_type: 'edit',
      rich_menu_id: data._id,
    })
  }

  openConditionSetting() {
    if (!this.conditionSetting.display_setting) {
      return
    }
    this.conditionSettingModalVisible = true
  }

  updateConditionSetting(data: IRichMenuConditionSetting) {
    this.conditionSetting = data
  }

  async onChangeDisplaySetting(val, oldVal) {
    if (val === oldVal) {
      return
    }
    this.loading = true
    this.conditionSetting.display_setting = val
    if (this.conditionSetting._id === '' && this.conditionSetting.display_setting) {
      const { dispatch } = this.$store
      this.conditionSetting.test_detail = this.conditionSetting.prod_detail
      await dispatch(ACTION_RICH_MENU_CONDITION_SETTING.ADD, {
        ...this.conditionSetting,
      })
      await this.appIdChanged()
    } else {
      if (this.conditionSetting.display_setting) {
        const isSuccess = await this.$store.dispatch(ACTION_RICH_MENU_CONDITION_SETTING.IS_ACTIVE, {
          ...this.conditionSetting,
        })
        if (isSuccess) {
          this.$q.notify({
            message: this.$t('messages.saved'),
            color: 'positive',
          })
        }
        await this.appIdChanged()
      } else {
        this.defaultRichMenuModalVisible = true
      }
    }
  }

  onCloseSettingModal() {
    if (this.conditionSetting._id === '') {
      this.conditionSetting.display_setting = false
    }
    this.conditionSettingModalVisible = false
  }

  onCloseDefaultRichMenuModal() {
    this.defaultRichMenuModalVisible = false
    this.conditionSetting.display_setting = true
    this.loading = false
  }

  async setDefaultRichMenu(menu: IRichMenu) {
    this.defaultRichMenuModalVisible = false
    if (this.conditionSetting.prod_detail) {
      this.conditionSetting.prod_detail.default_rich_menu_id = menu._id
      this.conditionSetting.prod_detail.priority_rich_menu = []
    }
    if (this.conditionSetting.test_detail) {
      this.conditionSetting.test_detail.default_rich_menu_id = menu._id
      this.conditionSetting.test_detail.priority_rich_menu = []
    }

    const isSuccess = await this.$store.dispatch(ACTION_RICH_MENU_CONDITION_SETTING.IS_ACTIVE, {
      ...this.conditionSetting,
      default_rich_menu_id: menu._id,
    })

    if (isSuccess) {
      menu.is_active = true
      await this.$store.dispatch(ACTION_RICH_MENU.IS_ACTIVE, menu)
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
    }
    await this.appIdChanged()
  }

  goto(name: string, params = {}) {
    this.$router.push({
      name,
      params,
    })
  }
}
</script>
<style lang="sass" scoped></style>
